import { inboxConstants } from '@constants/inbox';
import { inboxService } from '@services';

export const inboxActions = {
    getHistory,
    update,
    reset,
};

function getHistory(conversationId, withLoading = true) {
    return dispatch => {
        if (withLoading) {
            dispatch(request());
        }
        inboxService.getHistory(conversationId).then(
            data => dispatch(success(data)),
            () => dispatch(failure()),
        );
    };
}

function request() {
    return { type: inboxConstants.INBOX_HISTORY_FETCH };
}

function success(data) {
    return { type: inboxConstants.INBOX_HISTORY_SUCCESS, data };
}

function failure() {
    return { type: inboxConstants.INBOX_HISTORY_ERROR };
}

function update(data) {
    return { type: inboxConstants.INBOX_HISTORY_UPDATE, data };
}

function reset() {
    return { type: inboxConstants.INBOX_RESET };
}
